var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3393 -0.955231V18.9067L24.3355 18.9105H-6.97363V-0.955231H24.3393Z",
    fill: "#314589"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3393 16.8381V18.9067L24.3355 18.9105H21.0772L11.4668 12.8133L10.505 12.2028L9.36989 11.4809L8.98872 11.239L7.83484 10.5086L7.40378 10.2333L7.04237 10.0057L6.31484 9.54666L6.08048 9.39618L5.7266 9.17237L2.3139 7.0038L0.778837 6.03142L-6.97363 1.11428V-0.955246L-6.94634 -0.994293L-6.88516 -0.955246H-3.71434L6.08048 5.25714L7.04237 5.86952L7.30025 6.03142L8.83531 7.0038L8.98872 7.10285L9.57789 7.47618L10.505 8.0638L10.6631 8.16666L11.4668 8.67618L12.2518 9.17237L14.3591 10.5086L15.8951 11.4809L24.3393 16.8381Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3431 18.8495L24.3487 18.9219L22.2546 18.9105L11.4668 12.0667L10.5473 11.481L10.505 11.4552L9.57789 10.8676L9.01601 10.5086L7.99295 9.85905L7.04237 9.26L6.90778 9.17238L6.31484 8.79524L6.08048 8.64857L1.96001 6.03143L-6.97363 0.362857V-1L-6.94634 -0.994286L4.13037 6.03143L5.66166 7.00381L6.08048 7.26952L7.04237 7.8819L7.40378 8.11048L7.99295 8.48476L10.505 10.0771L10.6631 10.179L11.1854 10.5086L11.4668 10.6886L24.3431 18.8495Z",
    fill: "#DB3B39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3393 -0.56285V1.50382L17.1995 6.03144L12.2518 9.17239L11.4668 9.66763L10.6631 10.1791L10.505 10.2791L10.1426 10.5086L9.57789 10.8676L8.98872 11.2391L8.60754 11.481L7.04237 12.4743L6.08048 13.0867L-3.10352 18.9105H-6.97363V17.2286L2.08707 11.481L3.61837 10.5086L5.7266 9.17239L6.08048 8.94763L6.31484 8.79525L7.04237 8.33525L7.40378 8.11049L8.98872 7.10287L9.14307 7.00382L10.505 6.14096L10.6781 6.03144L11.4668 5.53048L21.6927 -0.955231H24.0937L24.3393 -0.56285Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2584 -0.460945L14.025 6.03144L12.4899 7.00382L11.4668 7.65525L10.6631 8.16668L9.07719 9.17239L7.99295 9.85906L7.40378 10.2333L7.04236 10.4619L6.96895 10.5086L6.08048 11.0733L5.4339 11.481L-6.26869 18.9105H-6.97363V17.98L3.26448 11.481L4.79954 10.5086L6.08048 9.69525L6.31484 9.54668L6.90778 9.17239L7.04236 9.08382L7.99295 8.48477L10.3205 7.00382L10.505 6.88858L11.4668 6.2762L11.8555 6.03144L22.8654 -0.955231H24.3393L24.3431 -0.519993L24.2584 -0.460945Z",
    fill: "#DB3B39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-7 11.481H24.3553V6.03143H-7V11.481Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-7 10.5086H24.3553V7.00381H-7V10.5086Z",
    fill: "#DB3B39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4965 11.481H11.4594V18.9105H6.073V11.481H7.03488V6.03144H6.073V-0.955231H11.4594V6.03144H10.4965V11.481Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01599 18.9105H10.5153V-0.955231H7.01599V18.9105Z",
    fill: "#DB3B39"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.62a93e7bbc1f49cf389180a2ff78c3ce.svg";
export { ForwardRef as ReactComponent };